import React, { useMemo } from 'react';
import { useInicioApps } from './InicioAppsContext';
import {
  imagenDesdeItem,
  itemEsAccesoLogoAncho,
  redireccionarAccesoRapido,
} from './inicioAppsShared';
import '../../global/css/inicioAppsMovilGrid.css';

function CeldaWide({ item, onOpen }) {
  const src = imagenDesdeItem(item);
  const nombre = String(item?.nombre || 'Enlace').trim();
  const compact = itemEsAccesoLogoAncho(item);
  return (
    <button
      type="button"
      className={[
        'inicio-apps-movil-wide',
        compact ? 'inicio-apps-movil-wide--compact' : '',
      ]
        .filter(Boolean)
        .join(' ')}
      onClick={() => onOpen(item)}
    >
      {src ? (
        <span className="inicio-apps-movil-wide-icon-wrap">
          <img src={src} alt="" className="inicio-apps-movil-wide-icon" />
        </span>
      ) : null}
      <span className="inicio-apps-movil-wide-texto">{nombre}</span>
    </button>
  );
}

function CeldaNarrow({ item, onOpen }) {
  const src = imagenDesdeItem(item);
  const ini = (item?.nombre || '?').slice(0, 2).toUpperCase();
  const compact = itemEsAccesoLogoAncho(item);
  return (
    <button
      type="button"
      className={[
        'inicio-apps-movil-narrow',
        compact ? 'inicio-apps-movil-narrow--compact' : '',
      ]
        .filter(Boolean)
        .join(' ')}
      onClick={() => onOpen(item)}
      aria-label={item?.nombre || 'App'}
    >
      {src ? (
        <img src={src} alt="" />
      ) : (
        <span className="inicio-apps-movil-narrow-iniciales">{ini}</span>
      )}
    </button>
  );
}

export default function InicioAppsGridMovil() {
  const { items, cargado } = useInicioApps();

  const filas = useMemo(() => {
    const list = items || [];
    const out = [];
    for (let r = 0; 2 * r < list.length; r += 1) {
      const i = 2 * r;
      const a = list[i];
      const b = list[i + 1];
      const espejo = r % 2 === 1;
      out.push({ a, b, espejo });
    }
    return out;
  }, [items]);

  if (!cargado || !items.length) return null;

  return (
    <div className="inicio-apps-movil-wrap">
      <h3 className="inicio-apps-movil-titulo">Accesos rápidos</h3>
      {filas.map(({ a, b, espejo }, idx) => {
        const solo = a && !b;
        return (
          <div
            key={`${a?.id ?? idx}-${b?.id ?? ''}`}
            className={[
              'inicio-apps-movil-fila',
              solo ? 'inicio-apps-movil-fila--solo' : '',
              !solo && espejo ? 'inicio-apps-movil-fila--espejo' : '',
            ]
              .filter(Boolean)
              .join(' ')}
          >
            {!solo && !espejo && (
              <>
                <CeldaWide item={a} onOpen={redireccionarAccesoRapido} />
                <CeldaNarrow item={b} onOpen={redireccionarAccesoRapido} />
              </>
            )}
            {!solo && espejo && (
              <>
                <CeldaNarrow item={a} onOpen={redireccionarAccesoRapido} />
                <CeldaWide item={b} onOpen={redireccionarAccesoRapido} />
              </>
            )}
            {solo && <CeldaWide item={a} onOpen={redireccionarAccesoRapido} />}
          </div>
        );
      })}
    </div>
  );
}
